export const DEFAULT_LINKS = {
  investor: "https://www.acefund-club-invest.io/club-order-investor",
  industry: {
    fr: "https://www.acefund-club-invest.io/815e2f2b-5d2aba75",
    en: "https://www.acefund-club-invest.io/815e2f2b",
  },
  circle: "https://www.acefund-club-invest.io/club-order-business-circle",
  private: "https://calendly.com/info-45106/60min",
};

const AMBASSADOR_KEYS = {
  lyon: "sa00061252330ef4c17c0066ce316c67e13646b7df34",
  bordeaux: "sa002595396311ff1b027e3a2060e08701767437ef",
  paris: "sa0228224645e9218b7fc7e6c5978f49dc6494ae41",
  brussels: "sa0263607702f2e2cc484f281cd1367dc344ec52fe",
  liege: "sa0263607742d095356ae08c353ee111316482eae1",
  martinique: "sa0132245789e2a36773171291b1e2d41991eabf57",
  normandie: "sa0249286856753b9fb1a56b691005073614c06d0c",
};

export const AMBASSADORS = Object.keys(AMBASSADOR_KEYS).reduce((acc, city) => {
  const saKey = AMBASSADOR_KEYS[city];

  acc[city] = {
    name: city,
    links: {
      investor: `${DEFAULT_LINKS.investor}?sa=${saKey}`,
      industry: {
        fr: `${DEFAULT_LINKS.industry.fr}?sa=${saKey}`,
        en: `${DEFAULT_LINKS.industry.en}?sa=${saKey}`,
      },
      circle: `${DEFAULT_LINKS.circle}?sa=${saKey}`,
      private: DEFAULT_LINKS.private,
    },
  };
  return acc;
}, {});
